var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShippingIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42041 17.5039C6.12744 17.7383 4.48682 18.3242 4.48682 16.3906V10.2969H2.55322V16.332C2.55322 20.7266 7.29932 19.3203 8.29541 18.6172V10.2969H6.42041V17.5039ZM0.619629 4.14453V17.0938C0.619629 23.1875 4.95557 25.0039 11.5767 27.875C18.1978 25.0039 22.5923 23.1875 22.5923 17.0938V4.14453C15.7954 0.570312 6.06885 1.27344 0.619629 4.14453ZM21.5962 17.0938C21.5962 22.1914 18.4321 23.7734 11.5767 26.8203C4.72119 23.7734 1.61572 22.1914 1.61572 17.0938V9.71094C7.59229 4.20312 15.1509 3.85156 21.5962 4.4375V17.0938ZM9.2915 10.8242V23.3047H11.2251V19.2617C12.6313 19.6719 15.3853 19.0859 15.3853 14.6328C15.3853 8.94922 10.6978 9.88672 9.2915 10.8242ZM11.2251 17.6797V11.8203C11.6938 11.5859 13.4517 11.0586 13.4517 14.6914C13.4517 18.6758 11.3423 17.7383 11.2251 17.6797ZM15.854 12.6406C15.854 15.3945 18.8423 15.1016 18.9009 16.7422C18.9595 18.1484 17.1431 18.0898 15.9126 17.0352V18.793C18.022 20.082 20.7173 19.2617 20.7759 16.8594C20.8931 13.8125 17.6118 14.1055 17.6704 12.5234C17.729 11.3516 19.4868 11.3516 20.5415 12.4062V10.7656C18.8423 9.47656 15.854 10.2383 15.854 12.6406Z",
    fill: "#465365"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingIcon);
export default __webpack_public_path__ + "static/media/shipping-icon.1a55f8303f17dbc279144a1a671c1dfc.svg";
export { ForwardRef as ReactComponent };